<div class="register">
    <div class="body">
        <div class="phone-c flex flex-col gap-16">
            <fun-phone-input 
            [dataValue]="data?.phone"
            (sendValueEvent)="getPhoneValue($event)" 
            (sendErrorEvent)="getPhoneError()"
            labelName="{{ 'register.phone.phone' | translate }}" 
            placeholder="{{ 'register.phone.phone' | translate }}">
            </fun-phone-input>
        </div>
    </div>
</div>